<template>
	<div class="content">
		<div class="content-header">
			<!-- 导航 -->
			<!-- <div class="content-header-tab">
				<div :class="{chang:num==1}" @click="toUrl(0)" style="cursor:pointer">首页</div>
				<div
					:class="{chang:num==(item.id+1)}"
					v-for="(item, index) in cate"
					:key="index"
					@click="toUrl(item.id)"
					style="cursor:pointer"
				>{{item.title}}</div>
			</div>-->
			<div class="content-header-tab">
				<div style="cursor:pointer">
					<a href="http://www.005.tv/zx/">首页</a>
				</div>
				<div style="cursor:pointer">
					<a href="http://www.005.tv/zx/">二次元资讯</a>
				</div>
				<div style="cursor:pointer">
					<a href="http://www.005.tv/zwh/">慢慢说</a>
				</div>
				<div style="cursor:pointer">
					<a href="http://www.005.tv/Cosplay/">COS本子图</a>
				</div>
				<div style="cursor:pointer">
					<a href="http://www.005.tv/zh/">展会资讯</a>
				</div>
				<div style="cursor:pointer">
					<a href="http://www.005.tv/erciyuanshouyou/">二次元手游</a>
				</div>
				<div style="cursor:pointer">
					<a href="http://www.005.tv/2016/51139.html?1468379289">投稿专区</a>
				</div>
			</div>
			<div class="content-header-right">
				<div class="content-header-right-search" v-if="flagg == '1'">
					<input type="text" placeholder="搜索" v-model="searchtitle" @keyup.enter="tosearch" />
					<img src="../img/sousuo.png" @click="tosearch" />
				</div>
				<div v-if="show" class="content-header-right-btn2">
					<router-link to="/Usercenter">
						<img src="../img/user.png" class="content-header-right-user" />
					</router-link>
					<div class="content-header-right-btn" @click="logout">退出</div>
				</div>
				<div class="content-header-right-btn" v-if="!show">
					<router-link to="/login" class="content-header-right-btn-router-link">
						<img src="../img/user.png" class="content-header-right-user" />
					</router-link>
					<router-link to="/login" class="content-header-right-btn-router-link">登录/</router-link>
					<router-link to="/register" class="content-header-right-btn-router-link">注册</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "App",
		props: ["flagg", "num"],
		components: {},
		data() {
			return {
				cate: "",
				show: false,
				searchtitle: ""
			};
		},
		beforeCreate() {
			this.$http.get("conf").then(res => {
				this.cate = res.body.data.cate;
			});
		}, //生命周期 - 创建之前
		created() {
			if (this.$cookies.isKey("token")) {
				this.show = true;
				console.log("show", this.show);
			} else {
				this.show = false;
			}
		},
		methods: {
			toUrl(type) {
				if (type == 0) {
					this.$router.push("/index");
				}
				if (type == 1) {
					this.$router.push("/TwoD");
				}
				if (type == 2) {
					this.$router.push("/publicnum");
				}
				if (type == 3) {
					this.$router.push("/Novel");
				}
				if (type == 4) {
					this.$router.push("/Exhibition");
				}
				if (type == 5) {
					this.$router.push("/Cartoon");
				}
			},
			logout() {
				this.$http
					.post(`user/logout`, {
						token: this.$cookies.get("token")
					})
					.then(res => {
						if (res.body.code == 1) {
							this.$cookies.remove("token");
							this.show = false;
							this.$router.go(0);
						}
					});
			},
			tosearch() {
				if (this.searchtitle) {
					const serach = this.$router.resolve({
						path: "/searchzixun",
						query: { searchtitle: this.searchtitle }
					});
					window.open(serach.href, "_blank");
				}
			}
		}
	};
</script>

<style scoped="scoped">
	.chang {
		background-color: #404040;
		color: #fff !important;
		height: 40px;
		line-height: 40px;
		padding: 0 10px;
	}
	.content {
		width: 100%;
		background-color: #efefef;
		border-bottom: 2px solid #cccccc;
	}
	.content-header {
		width: 1200px;
		height: 40px;
		background-color: #efefef;
		display: flex;
		flex-direction: row;
		align-content: center;
		margin: 0 auto;
		justify-content: space-between;
	}
	.content-header-tab {
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	.content-header-tab div {
		width: fit-content;
		height: 40px;
		padding: 0 30px;
		line-height: 40px;
		color: #212121;
		font-size: 14px;
	}
	.content-header-right {
		display: flex;
		align-items: center;
		flex-direction: row;
	}
	.content-header-right-search {
		display: flex;
		justify-content: space-between;
		background-color: #ffffff;
		border-radius: 14px;
		height: 28px;
		width: 180px;
		align-items: center;
		padding: 0 16px;
	}
	.content-header-right-search > input {
		background: none;
		outline: none;
		border: 0px;
		width: 120px;
	}
	.content-header-right-search > img {
		height: 16px;
		width: 16px;
	}
	.content-header-right-user {
		height: 24px;
		width: 24px;
		margin: 0 10px;
	}
	.content-header-right-btn {
		color: #212121;
		font-size: 14px;
		display: flex;
		margin-left: 4px;
		align-items: center;
	}
	.content-header-right-btn2 {
		display: flex;
		flex-direction: row;
		cursor: pointer;
	}
	.content-header-right-btn-router-link {
		color: #212121 !important;
		font-size: 14px;
	}
</style>



// WEBPACK FOOTER //
// src/components/loginheader.vue